module.exports = __webpack_public_path__ + "static/media/IMG_4646.5590814d.HEIC";